import { render } from "./PermissionsUser.vue?vue&type=template&id=46fe82be"
import script from "./PermissionsUser.vue?vue&type=script&lang=js"
export * from "./PermissionsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__